import { useEffect, useState } from "react";

import { fetchRecommendations } from "../services/recommendation.service";
import { GetRecommendatioProps } from "../types/interface.types";
import { RecommendationModel } from "../types/model.types";

export function useRecommendations(props: GetRecommendatioProps) {
  const [recommendations, setRecommendations] = useState<RecommendationModel>();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadRecommendations = async () => {
      try {
        const response = await fetchRecommendations(props);
        setRecommendations(response);
      } catch (error) {
        console.error(error);
      } finally {
        setLoading(false);
      }
    };

    loadRecommendations();
  }, []);

  return { recommendations, loading };
}
